export const resolveDefaultScheduleAgentId = (
  scopedAgentId?: number,
  activeConversationAgentId?: number | null,
  firstAvailableAgentId?: number
): number | '' =>
  scopedAgentId || activeConversationAgentId || firstAvailableAgentId || '';

export const resolveConversationAgentId = (
  sessionData?: {
    agent?: number | { id?: number } | null;
    agent_id?: number | null;
  } | null
): number | null => {
  const agent = sessionData?.agent;
  if (typeof agent === 'number') {
    return agent;
  }
  if (agent && typeof agent === 'object' && typeof agent.id === 'number') {
    return agent.id;
  }
  return typeof sessionData?.agent_id === 'number'
    ? sessionData.agent_id
    : null;
};
